/**
 * Created by lihanying on 2017/6/23.
 */
import React, { createRef } from 'react'
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import { Form, Input, Select, Row, Col, Checkbox, Button, message } from 'antd'
import { checkPhoneNum, checkVerifyCode } from '../../../util'
const FormItem = Form.Item
const Option = Select.Option

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      countDown: 60,
      interval: '',
      isNum: false,
      regionList: [],
      regionIndex: 0, //所选地区下标
    }
  }
  formRef = createRef()

  componentDidMount() {
    this.props.fetRegionList((data) => {
      this.setState({
        regionList: data.detail,
      })
    })
  }

  onFinishFailed = ({ errorFields }) => {
    this.formRef.current.scrollToField(errorFields[0].name)
  }

  onFinish = (values) => {
    if (values.agreement) {
      const { regionList, regionIndex } = this.state
      if (checkVerifyCode(values.captcha)) {
        this.props.fetchBinding(
          values.phone,
          values.captcha,
          regionList[regionIndex].id
        )
      } else {
        alert('验证码不正确!')
      }
    }
  }

  getVerifyCode = () => {
    const { regionList, regionIndex, isNum } = this.state
    if (checkPhoneNum(this.state.phone)) {
      if (isNum) {
        return
      }
      this.props.fetchSendVerifyCode(
        this.state.phone,
        regionList[regionIndex].id
      )
      this.countDown()
    } else {
      message.error('请输入正确的手机号码')
    }
  }

  //倒计时
  countDown = () => {
    if (this.state.isNum) {
      return
    }
    clearInterval(this.state.interval)
    this.setState({ isNum: true })
    this.state.interval = setInterval(() => {
      let cd = this.state.countDown
      cd--
      this.setState({
        countDown: cd,
      })
      if (this.state.countDown === 0) {
        this.setState({ countDown: 60, isNum: false }, () =>
          clearInterval(this.state.interval)
        )
      }
    }, 1000)
  }
  //修改当前地区下标值 并触发验证
  updateRegionType = (e) => {
    this.setState({ regionIndex: e })
  }
  render() {
    const { regionList } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 6,
        },
      },
    }

    const selectBefore = (
      <Select
        defaultValue="+86"
        style={{ width: 80 }}
        onChange={(e) => this.updateRegionType(e)}
      >
        {regionList &&
          regionList.map((v, index) => (
            <Option key={index} value={index}>
              {v.calling_code}
            </Option>
          ))}
      </Select>
    )

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
        style={{ paddingTop: '2rem' }}
      >
        <FormItem
          {...formItemLayout}
          name="phone"
          rules={[{ required: true, message: '请输入您的电话号码进行绑定!' }]}
          label="电话号码"
        >
          <Input
            allowClear
            size="large"
            maxLength={11}
            addonBefore={selectBefore}
            style={{ width: '100%' }}
            onChange={(e) => this.setState({ phone: e.target.value })}
          />
        </FormItem>
        <FormItem
          {...formItemLayout}
          name="captcha"
          rules={[{ required: true, message: '请输入您收到的验证码!' }]}
          label="验证码"
        >
          <Row gutter={8}>
            <Col span={12}>
              <Input allowClear size="large" minLength={4} maxLength={6} />
            </Col>
            <Col span={12}>
              <Button size="large" style={{ width: '100%' }} disabled={this.state.isNum} onClick={this.getVerifyCode}>
                {!this.state.isNum && '获取验证码'}
                {this.state.isNum && (
                  <span
                    style={{
                      paddingLeft: '.5rem',
                      color: '#108EE9',
                      width: '2rem',
                      display: 'inline-block',
                    }}
                  >
                    {this.state.countDown}s
                  </span>
                )}
              </Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem
          {...tailFormItemLayout}
          name="agreement"
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Checkbox>
            我已经阅读<a href="">同意</a>
          </Checkbox>
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            完成
          </Button>
        </FormItem>
      </Form>
    )
  }
}

export default RegistrationForm



// WEBPACK FOOTER //
// ./src/containers/Binding/component/binding.js